import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import {
    EmailFormWrapper,
    EmailInput,
    JoinButton,
    SuccessMessage
} from "../assets/styles/ContentStyles";

const EmailInputComponent = ({ waitlistType }) => {
    const [email, setEmail] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (email) {
            setIsSubmitted(true);
            console.log("Joining waitlist with email:", email);

            try {
                await emailjs.send(
                    process.env.REACT_APP_EMAILJS_SERVICE_ID,
                    process.env.REACT_APP_EMAILJS_JOIN_WAITLIST_TEMPLATE_ID,
                    {
                        user_email: email,
                        waitlist_type: waitlistType
                    },
                    process.env.REACT_APP_EMAILJS_PUBLIC_KEY
                ).then(
                    function (response) {
                        console.log('SUCCESS!', response);
                    },
                    function (err) {
                        console.log('FAILED...', err);
                    }
                );
            } catch (error) {
                console.error("Error sending email:", error);
            }

            // Reset after 5 seconds
            setTimeout(() => {
                setEmail("");
                setIsSubmitted(false);
            }, 5000);
        }
    };

    return (
        <>
            {!isSubmitted ? (
                <form onSubmit={handleSubmit}>
                    <EmailFormWrapper>
                        <EmailInput
                            type="email"
                            placeholder="Email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                        <JoinButton type="submit">Join the Waitlist</JoinButton>
                    </EmailFormWrapper>
                </form>
            ) : (
                <SuccessMessage>
                    Thanks for joining! We'll be in touch soon.
                </SuccessMessage>
            )}
        </>
    );
};

export default EmailInputComponent;
